import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Popover, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
var BaseTableAction = function (_a) {
    var data = _a.data, listItems = _a.listItems, actions = _a.actions;
    var t = useCustomTranslation();
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleClickItem = function (type) {
        actions(type, data);
        handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx("button", { className: 'flex items-center rounded-full border-none bg-backgroundDefault cursor-pointer', onClick: handleOpen, children: _jsx("span", { className: 'text-xl', children: "..." }) }), _jsx(Popover, { open: Boolean(anchorEl), anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }, transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                }, PaperProps: {
                    sx: {
                        boxShadow: 2,
                        backgroundColor: 'var(--mui-palette-common-white)',
                        cursor: 'pointer'
                    }
                }, children: _jsx(List, { children: listItems.map(function (p) { return (_jsxs(ListItem, { onClick: function () { return handleClickItem(p.type); }, children: [p.icon && _jsx(ListItemIcon, { children: p.icon }), _jsx(ListItemText, { primary: t(p.label) })] }, p.type)); }) }) })] }));
};
export default BaseTableAction;
